// import "./new.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Select from "react-select";
// import Navbar from "../../components/navbar/Navbar";
// import { useNavigate } from "react-router-dom";
// import { useState, useEffect } from "react";
// import { expenseInputs } from "../../formSource";
// import { serverUrl } from "../../temp";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const ExpenseNew = ({ title }) => {
//   const navigate = useNavigate();
//   // const [file, setFile] = useState("");
//   const [inputValues, setInputValues] = useState({});
//   const [notification, setNotification] = useState("");
//   const [accountoptions, setAccountoptions] = useState([]);
//   const [transactionoptions, setTransactionoptions] = useState([]);
//   const [useroptions, setUseroptions] = useState([]);
//   const [isNotificationVisible, setIsNotificationVisible] = useState(false);
//   const center_id = localStorage.getItem("center_id");
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const handlePaperSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       type: selectedOption.value,
//     });
//   };

//   const handleCheckSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       checking_status: selectedOption.value,
//     });
//   };

//   const handleAccountSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       account_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     account_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const account_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/account_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setAccountoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleTransactionSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       transaction_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     transaction_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const transaction_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/transaction_ids`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].transaction_type;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setTransactionoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleUserSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       user_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     user_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const user_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/user_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setUseroptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleInputChange = (e) => {
//     console.log(e.target.name);
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//     console.log("inputValues", inputValues);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("account_id", inputValues.account_id);
//     formData.append("transaction_id", inputValues.transaction_id);
//     formData.append("description", inputValues.description);
//     formData.append("amount", inputValues.amount);
//     formData.append("user_id", inputValues.user_id);
//     formData.append("status", inputValues.status || 1);
//     // formData.append("logo", file); // Append the file to FormData

//     try {
//       // Send formData to the server using an HTTP request with multipart/form-data
//       const response = await fetch(`${serverUrl}/add_expense`, {
//         method: "POST",
//         body: formData, // Use formData here with multipart/form-data
//       });

//       const data = await response.json();
//       if (data.code >= 400) {
//         if (typeof data.message === "object") {
//           Object.entries(data.message).forEach(([field, errors]) => {
//             errors.forEach((errMsg) => {
//               toast.error(`${field}: ${errMsg}`);
//             });
//           });
//         } else {
//           toast.error(data.message || "Something went wrong.");
//         }

//         // Clear all input data and roles when error occurs
//         // setInputValues({});
//         // setSelectedUser([]);

//         // Force the component to rerender with the empty state
//         setTimeout(() => {}, 500); // Adding timeout to allow state change
//       } else {
//         toast.success("Expense added successfully!");

//         // Clear form data after success
//         setInputValues({});
//         // setSelectedUser([]);

//         // Navigate to the users page after success
//         setTimeout(() => {
//           navigate("/expense");
//         }, 1000);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };
//   const showNotification = (message) => {
//     setNotification(message);
//     setIsNotificationVisible(true);

//     // Automatically hide the notification after a certain time (e.g., 3 seconds)
//     setTimeout(() => {
//       setIsNotificationVisible(false);
//       setNotification("");
//     }, 3000); // Adjust the time as needed
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="new">
//           <Sidebar />
//           <div className="newContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               {/* <div className="left">
//                                 <img
//                                     src={
//                                         file
//                                     }
//                                     alt=""
//                                 />
//                             </div> */}
//               <div className="right">
//                 <form onSubmit={handleSubmit}>
//                   {/* <div className="formInput">
//                                         <label htmlFor="file">
//                                             Image: <DriveFolderUploadOutlinedIcon className="icon" />
//                                         </label>
//                                         <input
//                                             type="file"
//                                             id="file"
//                                             onChange={(e) => setFile(e.target.files[0])}
//                                             style={{ display: "none" }}
//                                         />
//                                     </div> */}
//                   {expenseInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       {input.fieldName === "status" ? null : (
//                         <>
//                           <label>{input.label}</label>
//                           {input.fieldName === "account_id" ? (
//                             <Select
//                               options={accountoptions}
//                               name={input.fieldName}
//                               onChange={handleAccountSelectChange}
//                               required
//                             />
//                           ) : input.fieldName === "transaction_id" ? (
//                             <Select
//                               options={transactionoptions}
//                               name={input.fieldName}
//                               onChange={handleTransactionSelectChange}
//                               required
//                             />
//                           ) : input.fieldName === "user_id" ? (
//                             <Select
//                               options={useroptions}
//                               name={input.fieldName}
//                               onChange={handleUserSelectChange}
//                               required
//                             />
//                           ) : (
//                             <input
//                               type={input.type}
//                               placeholder={input.placeholder}
//                               name={input.fieldName}
//                               onChange={handleInputChange}
//                               required={input.fieldName !== "status"}
//                             />
//                           )}
//                         </>
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formSubmit">
//                     <button type="submit" style={{ float: "right" }}>
//                       Send
//                     </button>
//                   </div>
//                 </form>
//                 {isNotificationVisible && (
//                   <div className="notification">{notification}</div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}{" "}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default ExpenseNew;



import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Select from "react-select";
import Navbar from "../../components/navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { expenseInputs } from "../../formSource";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const ExpenseNew = ({ title }) => {
  const navigate = useNavigate();
  const [inputValues, setInputValues] = useState({});
  const [accountOptions, setAccountOptions] = useState([]);
  const [transactionOptions, setTransactionOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const center_id = localStorage.getItem("center_id");
  const token = localStorage.getItem("token");

  const redirectToLogin = () => {
    alert("Please Login first then you can access this page...");
    window.location.href = "/";
  };

  useEffect(() => {
    fetchAccountNames();
    fetchTransactionNames();
    fetchUserNames();
  }, []);

  const fetchAccountNames = async () => {
    try {
      const response = await fetch(`${serverUrl}/account_ids/${center_id}`);
      if (!response.ok) throw new Error("Failed to fetch accounts");
      const data = await response.json();
      const nameList = data.data.map(({ id, name }) => ({
        value: id,
        label: name
      }));
      setAccountOptions(nameList);
    } catch (error) {
      console.error("Error fetching accounts:", error);
      toast.error("Failed to fetch account data");
    }
  };

  const fetchTransactionNames = async () => {
    try {
      const response = await fetch(`${serverUrl}/transaction_ids`);
      if (!response.ok) throw new Error("Failed to fetch transactions");
      const data = await response.json();
      const nameList = data.data.map(({ id, transaction_type }) => ({
        value: id,
        label: transaction_type
      }));
      setTransactionOptions(nameList);
    } catch (error) {
      console.error("Error fetching transactions:", error);
      toast.error("Failed to fetch transaction data");
    }
  };

  const fetchUserNames = async () => {
    try {
      const response = await fetch(`${serverUrl}/user_ids/${center_id}`);
      if (!response.ok) throw new Error("Failed to fetch users");
      const data = await response.json();
      const nameList = data.data.map(({ id, name }) => ({
        value: id,
        label: name
      }));
      setUserOptions(nameList);
    } catch (error) {
      console.error("Error fetching users:", error);
      toast.error("Failed to fetch user data");
    }
  };

  const handleAccountSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      account_id: selectedOption.value,
    });
  };

  const handleTransactionSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      transaction_id: selectedOption.value,
    });
  };

  const handleUserSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      user_id: selectedOption.value,
    });
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("center_id", localStorage.getItem("center_id"));
    formData.append("account_id", inputValues.account_id);
    formData.append("transaction_id", inputValues.transaction_id);
    formData.append("description", inputValues.description);
    formData.append("amount", inputValues.amount);
    formData.append("user_id", inputValues.user_id);
    formData.append("status", inputValues.status || 1);

    try {
      const response = await fetch(`${serverUrl}/add_expense`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        } else {
          toast.error(data.message || "Something went wrong.");
        }
      } else {
        toast.success("Expense added successfully!");
        setInputValues({});
        setTimeout(() => {
          navigate("/expense");
        }, 1000);
      }
    } catch (error) {
      console.log(error);
      toast.error("Network error. Please try again.");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="new">
          <Sidebar />
          <div className="newContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography variant="h5" component="h2" gutterBottom className="formTitle">
                    {title}
                  </Typography>
                  <form onSubmit={handleSubmit} className="responsiveForm">
                    <Grid container spacing={2}>
                      {expenseInputs.map((input) => (
                        input.fieldName !== "status" && (
                          <Grid item xs={12} sm={6} key={input.id} className="formGridItem">
                            <div className="formInput">
                              <label>{input.label}</label>
                              {input.fieldName === "account_id" ? (
                                <Select
                                  options={accountOptions}
                                  onChange={handleAccountSelectChange}
                                  required
                                  className="selectInput"
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      minHeight: '46px',
                                      borderColor: '#e2e8f0',
                                      '&:hover': {
                                        borderColor: '#cbd5e0'
                                      }
                                    }),
                                    valueContainer: (base) => ({
                                      ...base,
                                      padding: '2px 8px'
                                    }),
                                    input: (base) => ({
                                      ...base,
                                      margin: '0',
                                      padding: '0'
                                    }),
                                    indicatorsContainer: (base) => ({
                                      ...base,
                                      height: '44px'
                                    })
                                  }}
                                />
                              ) : input.fieldName === "transaction_id" ? (
                                <Select
                                  options={transactionOptions}
                                  onChange={handleTransactionSelectChange}
                                  required
                                  className="selectInput"
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      minHeight: '46px',
                                      borderColor: '#e2e8f0',
                                      '&:hover': {
                                        borderColor: '#cbd5e0'
                                      }
                                    }),
                                    valueContainer: (base) => ({
                                      ...base,
                                      padding: '2px 8px'
                                    }),
                                    input: (base) => ({
                                      ...base,
                                      margin: '0',
                                      padding: '0'
                                    }),
                                    indicatorsContainer: (base) => ({
                                      ...base,
                                      height: '44px'
                                    })
                                  }}
                                />
                              ) : input.fieldName === "user_id" ? (
                                <Select
                                  options={userOptions}
                                  onChange={handleUserSelectChange}
                                  required
                                  className="selectInput"
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      minHeight: '46px',
                                      borderColor: '#e2e8f0',
                                      '&:hover': {
                                        borderColor: '#cbd5e0'
                                      }
                                    }),
                                    valueContainer: (base) => ({
                                      ...base,
                                      padding: '2px 8px'
                                    }),
                                    input: (base) => ({
                                      ...base,
                                      margin: '0',
                                      padding: '0'
                                    }),
                                    indicatorsContainer: (base) => ({
                                      ...base,
                                      height: '44px'
                                    })
                                  }}
                                />
                              ) : (
                                <input
                                  type={input.type}
                                  placeholder={input.placeholder}
                                  name={input.fieldName}
                                  value={inputValues[input.fieldName] || ""}
                                  onChange={handleInputChange}
                                  required={input.fieldName !== "status"}
                                />
                              )}
                            </div>
                          </Grid>
                        )
                      ))}
                    </Grid>
                    <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mt: 4, pb: 2 }}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/expense")}
                        sx={{ minWidth: '120px', height: '42px' }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: '150px', height: '42px' }}
                      >
                        Create Expense
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default ExpenseNew;